import { Headphones, Zap, Flame, Gem, Crown } from 'lucide-react';

const TIER_CONFIG = {
  free:   { label: 'Listener',        color: '#9ca3af', Icon: Headphones },
  active: { label: 'Active Listener', color: '#60a5fa', Icon: Zap },
  super:  { label: 'Super Listener',  color: '#f97316', Icon: Flame },
  vip:    { label: 'VIP',             color: '#a855f7', Icon: Gem },
  elite:  { label: 'Elite',           color: '#eab308', Icon: Crown },
};

/**
 * Compact listener tier badge — use in comments, chat, profiles.
 * @param {{ tier: string, level?: number, size?: 'xs'|'sm'|'md', showLabel?: boolean, isTopSupporter?: boolean }} props
 */
export function ListenerBadge({ tier = 'free', level, size = 'sm', showLabel = false, isTopSupporter = false }) {
  const cfg = TIER_CONFIG[tier] || TIER_CONFIG.free;
  const { Icon, color, label } = cfg;

  const sizeMap = {
    xs: { icon: 'w-3 h-3', text: 'text-[9px]', pad: 'px-1 py-0', gap: 'gap-0.5' },
    sm: { icon: 'w-3.5 h-3.5', text: 'text-[10px]', pad: 'px-1.5 py-0.5', gap: 'gap-1' },
    md: { icon: 'w-4 h-4', text: 'text-xs', pad: 'px-2 py-1', gap: 'gap-1.5' },
  };
  const s = sizeMap[size] || sizeMap.sm;

  if (tier === 'free' && !showLabel) return null;

  return (
    <span
      data-testid="listener-badge"
      className={`inline-flex items-center ${s.gap} ${s.pad} rounded-full font-bold ${s.text} uppercase tracking-wider border whitespace-nowrap`}
      style={{
        color,
        borderColor: `${color}40`,
        background: `${color}15`,
      }}
    >
      <Icon className={s.icon} />
      {showLabel && <span>{label}</span>}
      {level && <span className="opacity-70">Lv.{level}</span>}
      {isTopSupporter && (
        <span className="ml-0.5" style={{ color: '#eab308' }} title="Top Supporter">
          <Crown className="w-3 h-3" />
        </span>
      )}
    </span>
  );
}

export { TIER_CONFIG as LISTENER_TIER_CONFIG };
